module.exports = __webpack_public_path__ + "img/contrend-logo.fe267250.svg";